import React from 'react';

import { ExpandableItem } from './slate_styles_menu.styles';
import PopoverMenu, { PopoverMenuItem, usePopoverMenu } from 'components/common/menu';

export default function SlateAlignmentMenu(props) {
  const { targetRef, isOpen, onClose, onToggle, setTargetRef } = usePopoverMenu();
  const chevronDir = isOpen ? 'up' : 'down';

  const onSetAlign = textAlign => {
    props.editor.focus();
    if (props.isSelectionInTable) {
      props.onChange(props.editor.setCellAlignment(textAlign));
    } else {
      props.onChange(props.editor.setAlignment(textAlign));
    }
    onClose();
  };

  return (
    <span>
      <ExpandableItem
        data-aid="slateTextAlignment"
        isActive={isOpen || !isTextAligned('left')}
        onClick={onToggle}
        title="Text alignment"
        ref={setTargetRef}
      >
        <span>
          <i className="fa fa-align-left" />
          <i className={`draftStylesMenu-item-chevron fa fa-angle-${chevronDir}`} />
        </span>
      </ExpandableItem>
      {renderMenu()}
    </span>
  );

  function renderMenu() {
    return (
      <PopoverMenu
        boundByWindow
        data-aid="textAlignment-menu"
        isOpen={isOpen}
        onClose={onClose}
        position="bottom"
        targetRef={targetRef}
      >
        <PopoverMenuItem data-aid="left" isActive={isTextAligned('left')} onClick={() => onSetAlign('left')}>
          Left
        </PopoverMenuItem>
        <PopoverMenuItem data-aid="right" isActive={isTextAligned('right')} onClick={() => onSetAlign('right')}>
          Right
        </PopoverMenuItem>
        <PopoverMenuItem data-aid="center" isActive={isTextAligned('center')} onClick={() => onSetAlign('center')}>
          Center
        </PopoverMenuItem>
        <PopoverMenuItem data-aid="justify" isActive={isTextAligned('justify')} onClick={() => onSetAlign('justify')}>
          Justify
        </PopoverMenuItem>
      </PopoverMenu>
    );
  }

  function isTextAligned(alignment) {
    if (!props.editor) {
      return false;
    }

    const value = props.editor.value;
    const { startBlock } = value;
    let existingAlignment;
    if (props.isSelectionInTable) {
      const cell = startBlock && value.document.getClosest(startBlock.key, p => p.type === 'table_cell');
      existingAlignment = cell && cell.data.get('textAlign');
    } else {
      existingAlignment = startBlock && startBlock.data.get('textAlign');
    }
    return (alignment === 'left' && !existingAlignment) || existingAlignment === alignment;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition/lib/slate/slate_alignment_menu.jsx